import { BuyRequest } from '@/js/services/RogueTypes'

export function applyRecipeToBuyRequestTree(buyRequest: BuyRequest, recipeData: any) {
  buyRequest.metadata ??= {}
  buyRequest.metadata.recipe = recipeData.recipeId

  if (Array.isArray(buyRequest.children)) {
    buyRequest.children.forEach(child => {
      applyRecipeToBuyRequestTree(child, recipeData)
      // applying IDs to the children so we can see what units they belong to in the BR
      child.metadata!.id ??= buyRequest.metadata?.id 
    })
  }
}
